import AdminLiveAnalyticsPage from '../../../components/admin/analytics/AdminLiveAnalyticsPage'

export default function AdminAnalytics() {
  return <AdminLiveAnalyticsPage />
}
